module.exports = __webpack_public_path__ + "media/images/fb_black-787178977fe6361497043f95d94c765f.png";